import { Component, OnInit } from '@angular/core';
import {ServiceCommercialComponent} from "./service-commercial/service-commercial.component";

@Component({
    selector: 'app-service-commercial-dialog',
    templateUrl: './service-commercial-dialog.component.html',
    styleUrls: ['./service-commercial-dialog.component.scss'],
    standalone: false
})
export class ServiceCommercialDialogComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  openCommercialServicePopUp() {
  
  }

}
